import { c as _c } from "react/compiler-runtime";
import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { logError } from 'commons/logger';
import { useEffect } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';
const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';
const useJbEventFBAddToCart = t0 => {
  const $ = _c(18);
  const {
    basicDetails: t1,
    selectedOptionsVariantSku: t2
  } = t0;
  const basicDetails = t1 === undefined ? DEFAULT_BASIC_DETAILS : t1;
  const selectedOptionsVariantSku = t2 === undefined ? DEFAULT_VARIANT_SKU : t2;
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state
  } = useMetaFormattedCityStateZip();
  let t3;
  if ($[0] !== basicDetails.productName || $[1] !== basicDetails.productType || $[2] !== basicDetails.sku || $[3] !== basicDetails.value || $[4] !== city || $[5] !== selectedOptionsVariantSku || $[6] !== state || $[7] !== zip) {
    t3 = () => {
      const sku = basicDetails?.sku ? basicDetails.sku + selectedOptionsVariantSku : null;
      window.jbEventFBAddToCart = () => {
        if (basicDetails?.sku) {
          sendFBEvent(FB_EVENTS.ADD_TO_CART, {
            content_category: basicDetails.productType,
            content_ids: [sku],
            content_name: basicDetails.productName,
            content_type: "product",
            currency: "USD",
            value: basicDetails.value,
            zp: zip,
            ct: city,
            st: state
          });
        } else {
          logError(new Error("window.jbEventFBAddToCart: missing sku"));
        }
      };
    };
    $[0] = basicDetails.productName;
    $[1] = basicDetails.productType;
    $[2] = basicDetails.sku;
    $[3] = basicDetails.value;
    $[4] = city;
    $[5] = selectedOptionsVariantSku;
    $[6] = state;
    $[7] = zip;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = basicDetails?.sku;
  let t5;
  if ($[9] !== basicDetails.productName || $[10] !== basicDetails.productType || $[11] !== basicDetails.value || $[12] !== city || $[13] !== selectedOptionsVariantSku || $[14] !== state || $[15] !== t4 || $[16] !== zip) {
    t5 = [t4, basicDetails.productType, basicDetails.productName, basicDetails.value, city, selectedOptionsVariantSku, state, zip];
    $[9] = basicDetails.productName;
    $[10] = basicDetails.productType;
    $[11] = basicDetails.value;
    $[12] = city;
    $[13] = selectedOptionsVariantSku;
    $[14] = state;
    $[15] = t4;
    $[16] = zip;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  useEffect(t3, t5);
};
export default useJbEventFBAddToCart;